import { useMemo } from 'react';
import { ConfirmPopup } from '~/commonComponents';

interface IConfirmCloseJobPopupProps {
  onGoBack: () => void;
  onConfirm: () => void;
  hasScheduledOnsiteInterviews?: boolean;
  isLoading?: boolean;
}

export const ConfirmCloseJobPopup = ({
  onGoBack,
  onConfirm,
  hasScheduledOnsiteInterviews = false,
  isLoading = false,
}: IConfirmCloseJobPopupProps) => {
  const description = useMemo(() => {
    if (hasScheduledOnsiteInterviews) {
      return "You have pending onsite interviews. Only interviews scheduled in the next 7 days will remain active. All others will be canceled and you won't be able to post new onsite interviews or receive candidates.";
    }

    return 'You will no longer receive new candidates and you will not be able to post more onsite interviews.';
  }, [hasScheduledOnsiteInterviews]);

  return (
    // @ts-expect-error -- ConfirmPopup still written in JavaScript
    <ConfirmPopup
      title="Are You Sure You Want to Close?"
      description={description}
      descriptionStyle={{ marginBottom: 38 }}
      leftButtonText="Go Back"
      leftButtonAction={onGoBack}
      leftButtonDisabled={isLoading}
      rightButtonText="Close Job"
      rightButtonAction={onConfirm}
      rightButtonLoading={isLoading}
      dismissiblePopup={false}
    />
  );
};
